"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchLocalPromise = dispatchLocalPromise;

var _selectors = require("../../selectors");

var _selectors2 = _interopRequireDefault(_selectors);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _compose = require("recompose/compose");

var _compose2 = _interopRequireDefault(_compose);

var _mapProps = require("recompose/mapProps");

var _mapProps2 = _interopRequireDefault(_mapProps);

var _withReducer = require("recompose/withReducer");

var _withReducer2 = _interopRequireDefault(_withReducer);

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function dispatchLocalPromise(actionProp, requestProp, promiseFn) {
  var dispatchProp = "__dispatch:" + requestProp;
  var dispatchType = requestProp + "=" + actionProp + "()";
  return (0, _compose2.default)((0, _withReducer2.default)(requestProp, dispatchProp, function (s, a) {
    return a;
  }, {}), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)(_defineProperty({}, actionProp, (0, _reselect.createSelector)(function (s, p) {
    return p[dispatchProp];
  }, promiseFn, function (dispatch, promiseFn) {
    return function () {
      return _selectors2.default.dispatchPromise(dispatchType, dispatch, promiseFn.apply(undefined, arguments));
    };
  })))), (0, _mapProps2.default)(function (props) {
    return _lodash2.default.omit(props, [dispatchProp]);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL3V0aWwvYWN0aW9ucy5qcyJdLCJuYW1lcyI6WyJkaXNwYXRjaExvY2FsUHJvbWlzZSIsImFjdGlvblByb3AiLCJyZXF1ZXN0UHJvcCIsInByb21pc2VGbiIsImRpc3BhdGNoUHJvcCIsImRpc3BhdGNoVHlwZSIsInMiLCJhIiwicCIsImRpc3BhdGNoIiwiZGlzcGF0Y2hQcm9taXNlIiwib21pdCIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7OztRQVNnQkEsb0IsR0FBQUEsb0I7O0FBUmhCOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7Ozs7O0FBRU8sU0FBU0Esb0JBQVQsQ0FDTEMsVUFESyxFQUVMQyxXQUZLLEVBR0xDLFNBSEssRUFJTDtBQUNBLE1BQU1DLGVBQWUsZ0JBQWdCRixXQUFyQztBQUNBLE1BQU1HLGVBQWVILGNBQWMsR0FBZCxHQUFvQkQsVUFBcEIsR0FBaUMsSUFBdEQ7QUFDQSxTQUFPLHVCQUNMLDJCQUFZQyxXQUFaLEVBQXlCRSxZQUF6QixFQUF1QyxVQUFDRSxDQUFELEVBQUlDLENBQUo7QUFBQSxXQUFVQSxDQUFWO0FBQUEsR0FBdkMsRUFBb0QsRUFBcEQsQ0FESyxFQUVMLHlCQUNFLDREQUNHTixVQURILEVBQ2dCLDhCQUNaLFVBQUNLLENBQUQsRUFBSUUsQ0FBSjtBQUFBLFdBQVVBLEVBQUVKLFlBQUYsQ0FBVjtBQUFBLEdBRFksRUFFWkQsU0FGWSxFQUdaLFVBQUNNLFFBQUQsRUFBV04sU0FBWDtBQUFBLFdBQXlCO0FBQUEsYUFDdkIsb0JBQUVPLGVBQUYsQ0FBa0JMLFlBQWxCLEVBQWdDSSxRQUFoQyxFQUEwQ04scUNBQTFDLENBRHVCO0FBQUEsS0FBekI7QUFBQSxHQUhZLENBRGhCLEVBREYsQ0FGSyxFQVlMLHdCQUFTO0FBQUEsV0FBUyxpQkFBRVEsSUFBRixDQUFPQyxLQUFQLEVBQWMsQ0FBQ1IsWUFBRCxDQUFkLENBQVQ7QUFBQSxHQUFULENBWkssQ0FBUDtBQWNEIiwiZmlsZSI6ImFjdGlvbnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IFIgZnJvbSBcIi4uLy4uL3NlbGVjdG9yc1wiXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoXCJcbmltcG9ydCBjb21wb3NlIGZyb20gXCJyZWNvbXBvc2UvY29tcG9zZVwiXG5pbXBvcnQgbWFwUHJvcHMgZnJvbSBcInJlY29tcG9zZS9tYXBQcm9wc1wiXG5pbXBvcnQgd2l0aFJlZHVjZXIgZnJvbSBcInJlY29tcG9zZS93aXRoUmVkdWNlclwiXG5pbXBvcnQge2NyZWF0ZVN0cnVjdHVyZWRTZWxlY3RvciwgY3JlYXRlU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQge2Nvbm5lY3R9IGZyb20gXCJyZWFjdC1yZWR1eFwiXG5cbmV4cG9ydCBmdW5jdGlvbiBkaXNwYXRjaExvY2FsUHJvbWlzZShcbiAgYWN0aW9uUHJvcDogc3RyaW5nLFxuICByZXF1ZXN0UHJvcDogc3RyaW5nLFxuICBwcm9taXNlRm46IChPYmplY3QsIE9iamVjdCkgPT4gKC4uLk9iamVjdCkgPT4gUHJvbWlzZTwqPixcbikge1xuICBjb25zdCBkaXNwYXRjaFByb3AgPSBcIl9fZGlzcGF0Y2g6XCIgKyByZXF1ZXN0UHJvcFxuICBjb25zdCBkaXNwYXRjaFR5cGUgPSByZXF1ZXN0UHJvcCArIFwiPVwiICsgYWN0aW9uUHJvcCArIFwiKClcIlxuICByZXR1cm4gY29tcG9zZShcbiAgICB3aXRoUmVkdWNlcihyZXF1ZXN0UHJvcCwgZGlzcGF0Y2hQcm9wLCAocywgYSkgPT4gYSwge30pLFxuICAgIGNvbm5lY3QoXG4gICAgICBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICBbYWN0aW9uUHJvcF06IGNyZWF0ZVNlbGVjdG9yKFxuICAgICAgICAgIChzLCBwKSA9PiBwW2Rpc3BhdGNoUHJvcF0sXG4gICAgICAgICAgcHJvbWlzZUZuLFxuICAgICAgICAgIChkaXNwYXRjaCwgcHJvbWlzZUZuKSA9PiAoLi4uYXJncykgPT5cbiAgICAgICAgICAgIFIuZGlzcGF0Y2hQcm9taXNlKGRpc3BhdGNoVHlwZSwgZGlzcGF0Y2gsIHByb21pc2VGbiguLi5hcmdzKSksXG4gICAgICAgICksXG4gICAgICB9KSxcbiAgICApLFxuICAgIG1hcFByb3BzKHByb3BzID0+IF8ub21pdChwcm9wcywgW2Rpc3BhdGNoUHJvcF0pKSxcbiAgKVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/util/actions.js
// module id = 95
// module chunks = 0